import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";

export default function About() {
  return (
    <>
      <Seo title="About Us" path="/about" />
      <PageHeader eyebrow="About us" title="Numerology, done with care"
        subtitle="Aetheria exists to make numerology feel considered rather than gimmicky — accurate calculations, honest language, and a beautiful finished report." />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20 space-y-6 text-slate-600 leading-relaxed">
        <p>
          We built Aetheria for people who are curious about numerology but tired of flashy, over-promising
          websites. Our approach is simple: compute your numbers with a documented, testable engine, then
          write an interpretation that is warm, specific, and grounded in those numbers.
        </p>
        <p>
          Every Aetheria report pairs time-honoured numerology methods with modern writing technology
          to create a reading that is personal, thoughtful, and entirely yours. We're open about that
          combination — and we always offer insight and reflection, never promises.
        </p>
        <p>
          Your privacy matters to us. We collect only what a report needs, we keep your details private, and
          we never share them with advertisers.
        </p>
      </section>
    </>
  );
}
